// 选人dlg组件

const userDlgMul = {
  namespaced: true,

  state: {
    dlgShow: false,

    dlgQuery: {},

    list: []
  },

  getters: {
    dlgShow: state => state.dlgShow,

    dlgQuery: state => state.dlgQuery,

    list: state => state.list
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val;
    },

    SET_DLGQUERY: (state, val) => {
      state.dlgQuery = val;
    },

    SET_LIST: (state, val) => {
      state.list = val;
    }
  },

  actions: {}
};

export default userDlgMul;
